







import { create } from "zustand";
 
export const useCallStore = create((set) => ({
  isCalling: false, // Indicates we are initiating a call
  isReceivingCall: false, // Indicates someone is calling us
  callActive: false, // Call has been accepted
 
  callerId: null,      // User ID of the caller (if receiving)
  callerName: "",      // Name of the caller
  callerSignal: null,  // WebRTC signal from the caller
  isVideo: true,       // Audio or Video call
 
  targetUserId: null,  // User ID we are calling
  targetUserName: "",  // Name of user we are calling
  groupId: null,       // If the call is group-based
  groupName: "",       // Name of the group
  participants: [],    // [{ userId, stream, name }]
  activeGroupCalls: [], // [{ groupId, groupName, senderName, isVideo }]
 
  // Track our local stream
  localStream: null,
 
  setCallState: (data) => set((state) => ({ ...state, ...data })),
 
  clearCallState: () => set({
    isCalling: false,
    isReceivingCall: false,
    callActive: false,
    callerId: null,
    callerName: "",
    callerSignal: null,
    isVideo: true,
    targetUserId: null,
    targetUserName: "",
    groupId: null,
    groupName: "",
    participants: [],
    localStream: null,
  })
}));
 






// import { create } from "zustand";

// export const useCallStore = create((set) => ({
//   isCalling: false, // Indicates we are initiating a call
//   isReceivingCall: false, // Indicates someone is calling us
//   callActive: false, // Call has been accepted
  
//   callerId: null,      // User ID of the caller (if receiving)
//   callerName: "",      // Name of the caller
//   callerSignal: null,  // WebRTC signal from the caller
//   isVideo: true,       // Audio or Video call
  
//   targetUserId: null,  // User ID we are calling
//   targetUserName: "",  // Name of user we are calling
//   groupId: null,       // If the call is group-based (for future scope)
  
//   // Track our local stream
//   localStream: null,
  
//   setCallState: (data) => set((state) => ({ ...state, ...data })),
  
//   clearCallState: () => set({
//     isCalling: false,
//     isReceivingCall: false,
//     callActive: false,
//     callerId: null,
//     callerName: "",
//     callerSignal: null,
//     isVideo: true,
//     targetUserId: null,
//     targetUserName: "",
//     groupId: null,
//     localStream: null,
//   })
// }));
